import S from './SkeletonStyles';

function DetailsPageSkeleton(): JSX.Element {
  return (
    <S.DetailsPageWrapper>
      <div className="header">
        <div className="details-row">
          <div className="overview-container">
            <div className="button" />
            <div className="preview-image" />
            <div className="description">
              <div className="title" />
              <div className="overview" />
            </div>
          </div>
        </div>
        <div className="tags-row">
          <div className="tag" />
          <div className="tag" />
          <div className="tag" />
        </div>
      </div>
      <div className="widgets-container" />
    </S.DetailsPageWrapper>
  );
}

export default DetailsPageSkeleton;
